import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';
import { getReduxModelStateFromStore } from 'client/data/luckdragon/redux/redux-model';
import { FeatureFlagModel } from 'client/data/models/feature-flag';
import { create404Error } from 'site-modules/shared/utils/errors';

const getFeatureFlagValueFromStore = (featureFlagName, store) => {
  const modelState = getReduxModelStateFromStore(store);
  return modelState.get('shop-3664-hidden-gems', FeatureFlagModel);
};

export const LEASE_DEALS_PATH = '/lease-deals';
export const LEASE_DEALS_STATE_PATH = '/lease-deals/:state';

// TODO: Move these routes to the site-modules/lease-deals/routes/ folder after cleaning up the feature flag.
// lease-deals route currently renders srp page and we'd like to keep this behaviour until we fully complete the work on "hidden gems" page

export const routes = [
  {
    path: LEASE_DEALS_PATH,
    exact: true,
    page: getLoadablePage((params, store) => {
      const shop3664HiddenGemsEnabled = getFeatureFlagValueFromStore('shop-3664-hidden-gems', store);

      if (shop3664HiddenGemsEnabled) {
        return import(/* webpackChunkName: "lease-deals" */ '../../lease-deals/pages/lease-deals-definition');
      }

      return import(/* webpackChunkName: "srp" */ '../../inventory/pages/usurp/lease-deals-definition');
    }),
    enableLooseEtag: true,
  },
  {
    path: LEASE_DEALS_STATE_PATH,
    exact: true,
    page: getLoadablePage((params, store) => {
      const shop3664HiddenGemsEnabled = getFeatureFlagValueFromStore('shop-3664-hidden-gems', store);

      if (!shop3664HiddenGemsEnabled) {
        throw create404Error();
      }

      return import(/* webpackChunkName: "lease-deals" */ '../../lease-deals/pages/lease-deals-state-definition');
    }),
    enableLooseEtag: true,
    shouldCallParseApi: true,
    disableFlatUrlUserSetLocation: true,
  },
];
